import { GridPrintExportMenuItem, type GridPrintExportMenuItemProps } from '@mui/x-data-grid-pro';

const PrintExportMenuOption = ({ options, ...props }: GridPrintExportMenuItemProps) => (
  <GridPrintExportMenuItem
    {...props}
    options={{
      hideFooter: true,
      hideToolbar: true,
      ...options,
    }}
  />
);

export default PrintExportMenuOption;
